import React from 'react';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';

export enum UploadErrorType {
  FailedUpload = 'failed_upload',
  ConcurrentUpload = 'concurrent_upload',
}

export interface ErrorDetails {
  message: string;
  subMessage: string;
}

export const errorDetails: Record<UploadErrorType, ErrorDetails> = {
  [UploadErrorType.FailedUpload]: {
    message:
      "Sorry, we encountered an error while uploading your Bonjoro. So you don't lose all your hard work, click the button below to download your recorded video.",
    subMessage: 'You can then manually upload the video to send again.',
  },
  [UploadErrorType.ConcurrentUpload]: {
    message:
      'One of your team member has already recorded a video for this person. Jump on to the next name in your tasklist or follow up with them directly.',
    subMessage:
      'We saved your recorded video if you would like to download it.',
  },
};

export interface UploadErrorModalProps extends ModalProps {
  errorType?: UploadErrorType;
  downloadLink?: string;
}

export const UploadErrorModal = ({
  errorType,
  downloadLink,
  ...modalProps
}: UploadErrorModalProps) => {
  if (!errorType) return <></>;

  const errorDetail = errorDetails[errorType];
  const { message, subMessage } = errorDetail;

  return (
    <Modal
      {...modalProps}
      hideCloseButton
      className='sm:!w-[475px] rounded-md !inset-px !p-0'
      overlayClassName='!z-[9999999999]'
    >
      <div className='flex flex-col gap-y-6 items-center justify-center text-center p-6'>
        <i className='icon icon-error !v2-bg-red-700 !w-[50px] !h-[50px]' />
        <span className='text-[25px] font-bold'>
          Error uploading your video
        </span>
        <div className='flex flex-col gap-y-4'>
          <span>{message}</span>
          <span>{subMessage}</span>
          <div className='flex flex-row gap-x-5 justify-center'>
            <Button
              variant={ButtonVariant.Secondary}
              onClick={modalProps?.onModalClose}
            >
              Leave and discard
            </Button>
            <a href={downloadLink} download='video.webm'>
              <Button variant={ButtonVariant.Primary}>Download video</Button>
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};
